import { render } from "./Area.vue?vue&type=template&id=1318b174&scoped=true&ts=true"
import script from "./areaHelper.ts?vue&type=script&lang=ts"
export * from "./areaHelper.ts?vue&type=script&lang=ts"

import "./Area.vue?vue&type=style&index=0&id=1318b174&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1318b174"]])

export default __exports__